import React, { useEffect } from 'react';

import { isBrowser } from '../../../helpers/is-browser';
import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { RichText } from '../../rich-text/rich-text';
import Button from '../../ui/button/button';
import {
  useGetLibraryConstantsDictionaryData,
  useIsMPLivliFamily,
} from '@/providers/ConfigProvider';
import ImageWrapper from '@/components/image-wrapper/Image-wrapper';
import InfoIcon from '@/assets/icons/info-icon.svg';
import { useUser } from '@/providers/UserProvider';

interface StaticOfferRedemptionProps {
  offerRedemptionDetails?: {
    internalName: string;
    richText: any;
  };
  handleClose: () => void;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
  node_locale: string;
  contentful_id?: string;
}

export const StaticOfferRedemption = ({
  offerRedemptionDetails,
  handleClose,
  tenantDetails,
  node_locale,
  contentful_id,
}: StaticOfferRedemptionProps) => {
  const dictionary = useGetLibraryConstantsDictionaryData();
  const isLivliFamily = useIsMPLivliFamily();

  const { user } = useUser();

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        contentful_id: contentful_id,
        name: tenantDetails?.offerName,
        success: true,
        user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      });
    }
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="w-full">
        <div className="bg-brand-blue-1/30 text-bodys font-sans text-brand-blue-3 rounded-md py-1 pl-3 flex gap-2 my-4">
          <InfoIcon /> <p>{'Muestre esta pantalla en la caja'}</p>
        </div>
        <div className="flex items-center mt-4 mb-8">
          {tenantDetails?.tenantLogo && (
            <ImageWrapper
              url={tenantDetails?.tenantLogo?.url}
              alt={
                tenantDetails?.tenantLogo?.description
                  ? tenantDetails?.tenantLogo.description
                  : ''
              }
              className="h-12 w-12 lg:h-16 lg:w-16 rounded-md bg-brand-white flex border border-brand-grey-2"
              imgClassName="!object-contain rounded-md"
              width={
                tenantDetails?.tenantLogo?.width
                  ? parseInt(tenantDetails?.tenantLogo?.width)
                  : undefined
              }
              height={
                tenantDetails?.tenantLogo?.height
                  ? parseInt(tenantDetails?.tenantLogo?.height)
                  : undefined
              }
            />
          )}
          <div className="ml-4 text-neutral-grey-700 font-sans">
            <div className="text-bodyl text-text-default">
              {tenantDetails?.tenantName}
            </div>
            <div className="text-bodyl font-bold">
              {tenantDetails?.offerName}
            </div>
          </div>
        </div>
        {offerRedemptionDetails && (
          <div className="card w-[100%] flex flex-col align-centre bg-background-primary rounded-r-[20px] rounded-l-[20px] p-4 xs:max-h-[50vh] md:max-h-none xs:overflow-y-scroll md:overflow-y-hidden">
            <RichText richText={offerRedemptionDetails?.richText} />
          </div>
        )}
      </div>

      <div className="button-container flex flex-col gap-4 mt-6 w-full">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.specialOfferClaimedOfferText}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          {dictionary?.cancelText}
        </Button>
      </div>
    </div>
  );
};
